import React from "react"
import NoContent from "components/elements/NoContent"
import AlertBoxWrapper from "components/elements/AlertBox/AlertBoxWrapper"
import { useIntercom } from "react-use-intercom"
import Button from "components/Buttons/Button"
import PendingTextingVerificationAlert from "./PendingTextingVerificationAlert"
import TextUpgradeAlert from "./TextUpgradeAlert"
import NewTextMenu from "./NewTextMenu"

type Props = {
  emailEnabled: boolean
  textsEnabled: boolean
}

const NoTexts = ({ emailEnabled, textsEnabled }: Props) => {
  const { show: showIntercom } = useIntercom()

  let alertContent

  if (!emailEnabled) {
    alertContent = (
      <PendingTextingVerificationAlert contactUs={showIntercom} />
    )
  }

  if (!textsEnabled) {
    alertContent = (
      <TextUpgradeAlert />
    )
  }

  return (
    <>
      {alertContent && (
        <AlertBoxWrapper absolute>
          {alertContent}
        </AlertBoxWrapper>
      )}
      <NoContent
        title="SMS & WhatsApp Messaging"
        icon="chat"
        descriptionItems={["Reach guests instantly with SMS and WhatsApp messaging in Diobox, with engagement rates as high as 98%. Send invites, RSVP forms, confirmations, QR codes, and important event updates from a single place."]}
        footer={(
          <NewTextMenu
            button={(
              <Button leftIcon="plus" size="lg">
                Create First Message
              </Button>
            )}
          />
        )}
      />
    </>
  )
}

export default NoTexts
